<ng-container *ngIf="holiday$ | async | ready as feature">
  <app-program-panel
    [class.active]="isScheduled && !isOutdated"
    [active]="isScheduled && !isOutdated"
    size="normal"
  >
    <ng-container message *ngIf="isMultiFamily">
      {{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.CIRCUIT' | translate }} {{ circuitIdToDisplay }}
    </ng-container>
    <ng-container message>
      <ng-container *ngIf="isHolidayAtHome; else holidayProgram">
        {{ '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.PANEL.HOLIDAY_AT_HOME.TITLE' | translate }}
      </ng-container>
      <ng-template #holidayProgram>
        {{ '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.PANEL.TITLE' | translate }}
      </ng-template>
    </ng-container>
    <ng-container description>
      <div data-at-scheduled-message *ngIf="isScheduled && !isOutdated; else inactive">
        {{
          '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.PANEL.ACTIVE_FROM_UNTIL'
            | translate
              : {
                  startDate: departureDate.toDate() | date: 'short',
                  endDate: returnDate.toDate() | date: 'short'
                }
        }}
      </div>
      <!-- Placeholder to not show "Invalid date" at the time of animation (* => void) -->
      <ng-template #inactive>
        {{
          '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.PANEL.ACTIVE_FROM_UNTIL'
            | translate
              : {
                  startDate: '-',
                  endDate: '-'
                }
        }}
      </ng-template>
    </ng-container>
    <button
      button
      class="deactivate-button"
      mat-stroked-button
      color="primary"
      gtm="onOpen"
      gtmAction="Deactivate holiday program dialog"
      gtmCategory="statusPanel"
      [disabled]="!(feature | executable: 'unschedule')"
      [viConfirm]="{
        title: deactivateDialogTitle | translate,
        content: deactivateDialogContent | translate,
        cancelBtn: '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.DEACTIVATE_DIALOG.CANCEL' | translate,
        confirmBtn: '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.DEACTIVATE_DIALOG.CONFIRM' | translate
      }"
      (confirm)="onUncheduleHolidayMode()"
    >
      {{ '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.PANEL.BUTTON' | translate }}
    </button>
  </app-program-panel>
</ng-container>
